export default __webpack_public_path__ + "6b5f439196ca22e9ab09a39b5292677e.png";